var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-status',{staticClass:"user__status",attrs:{"online":this.isOnline}})}
var staticRenderFns = []

export { render, staticRenderFns }